import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { AvatarPng } from '~/dashboard/types/dashboard.types'

interface AvatarWithLevelProps {
  avatar: AvatarPng
  /** Omit when the level is not known yet; the chip is left empty rather than showing a number. */
  level?: number
}

export default function AvatarWithLevel({ avatar, level }: AvatarWithLevelProps): React.ReactElement {
  return (
    <div className="relative">
      <div className="w-56 h-56 p-2 rounded overflow-hidden border border-white/10 shadow-lg">
        <div className="rounded border-4 border-white/10 bg-white shadow-purple/30">
          {/*
           * Same split as the dashboard's `AvatarImage`: only a ReadyPlayerMe avatar carries a full
           * URL (`src`); an under-13 avatar and the default are asset keys, which only render
           * through `srcKey`. Passing a key as `src` shows a broken image.
           */}
          {avatar.isExists && !avatar.isUnder13 ? (
            <ResponsiveImage
              className="h-full overflow-hidden"
              height={318}
              imageClassName="object-cover"
              loading="eager"
              src={avatar.url}
              width={318}
            />
          ) : (
            <ResponsiveImage
              className="h-full overflow-hidden"
              fit={avatar.isExists ? 'cover' : 'contain'}
              height={318}
              loading="eager"
              srcKey={avatar.url}
              width={318}
            />
          )}
        </div>
      </div>
      <div className="absolute flex justify-center items-center -bottom-4 -right-4 w-16 h-16 bg-purple-darker/70 border border-white/20 rounded-4">
        {/* ⚠ Ternary, not `&&`: `level` is a number, and `0 && …` renders a literal "0". */}
        {level ? <span className="text-green-lime font-extrabold text-lg">{level}</span> : null}
      </div>
    </div>
  )
}
